import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import { useManageApiKeyMutation } from '../api/ApiCredentials';
import Toast from '../../../components/ToastNotification';
import { API_KEY_ACTION_TYPE } from '../../../utils/contants';

const ManageCredentialModal = ({ onClose, selectedRow, paginationState }) => {
  const { api_key, is_revoked } = selectedRow;
  const [manageApiKeyApi] = useManageApiKeyMutation();

  const handleManageApiKey = async () => {
    try {
      const response = await manageApiKeyApi({ 
        api_key, 
        action: is_revoked ? API_KEY_ACTION_TYPE.RESTORE : API_KEY_ACTION_TYPE.REVOKE
      }).unwrap();
      
      paginationState.setPagination({
        ...paginationState.pagination,
        pageIndex: 0
      });

      const credData = response?.data;
      if (credData) {
        Toast.success(`Api Key ${credData?.status} successfully`);
      }
    } catch (err) {
      Toast.error(err?.data?.message || err?.message || 'Failed to fetch');
    } finally {
      onClose();
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{width: '450px'}}>
        <div>
          <h3>{is_revoked ? 'Restore' : 'Revoke'} API Key</h3>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>
        <div className="content_body">
        <p>Are you sure you want to {is_revoked ? 'restore' : 'revoke'} <strong>{api_key}</strong> API Key?</p>
          <div className='layout_footer'>
            <button onClick={handleManageApiKey} className='save-btn'>Save</button>
            <button onClick={onClose} className='cancel-btn'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageCredentialModal;
